/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IDropdownStyleProps } from '@fluentui/react/lib/Dropdown';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { LuisDropdown, LuisDropdownProps } from 'src/core/components/LuisDropdown';
import { getScopedTheme } from 'src/core/themes/luisStylist';

const theme = getScopedTheme('Dashboard');

const dropdownStyles = classNamesFunction<IDropdownStyleProps, any>()({
    root: {
        border: theme.dropdownBorder,
        height: theme.dropdownSmallHeight,
        borderRadius: theme.dropdownBorderRadius
    },
    title: {
        border: 'none',
        backgroundColor: 'transparent',
        fontSize: theme.xSmallFont,
        height: theme.dropdownSmallHeight,
        lineHeight: theme.largeLineHeight
    },
    caretDownWrapper: {
        fontSize: theme.xSmallFont,
        lineHeight: theme.largeLineHeight
    },
    dropdownItemsWrapper: {
        maxHeight: theme.maxDropdownHeight,
        overflowY: 'auto'
    }
});

/**
 * The special styled dropdown for dashboard page.
 */
export const AnalyticsDropdown = (props: LuisDropdownProps) => {
    const { styles } = props;

    return <LuisDropdown {...props} styles={mergeStyleSets(dropdownStyles, styles)} />;
};
